import { render, staticRenderFns } from "./form-base.vue?vue&type=template&id=28285d1e"
import script from "./form-base.vue?vue&type=script&lang=js"
export * from "./form-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports